import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface MessageCardProps {
  avatarSrc: string;
  avatarAlt?: string;
  firstName: string | null;
  lastName: string | null;
  time: string;
  message: string;
  userName: string;
  currentUser?: boolean;
  userOnline: boolean;
}

const MessageCard = ({
  avatarSrc,
  avatarAlt = "",
  firstName,
  lastName,
  time,
  message,
  userName,
  currentUser = false,
  userOnline,
}: MessageCardProps) => {
  const formattedTime = new Date(time).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  const displayName = userName;

  const UserStatus = () => (
    <div className="absolute top-0.5 z-10">
      <div className="flex h-3 w-3 items-center justify-center rounded-full bg-[#015BBF]">
        <div
          className={`inline-flex h-2 w-2 rounded-full ${userOnline ? "bg-[#33FF3B]" : "bg-[#ED1D1D]"}`}
        ></div>
      </div>
    </div>
  );

  const MessageContent = () => (
    <div className="inline-block w-full rounded-lg bg-gradient-to-r from-[#1181E84D] to-[#79BFFF4D] p-3 font-kanit text-[13px] font-semibold leading-[18px]">
      <div className="text-wrap break-all text-white">{message}</div>
    </div>
  );

  return (
    <div className="flex w-[20rem] items-start px-3">
      {currentUser ? (
        <>
          <div className="flex w-full flex-col items-end">
            <div className="flex items-center justify-end gap-2">
              <span className="font-montserrat text-[12px] font-semibold text-[#3B6E9C]">
                {formattedTime}
              </span>
              <span className="font-kanit text-[12px] font-medium">
                {displayName}
              </span>
            </div>
            <MessageContent />
          </div>
          <div className="relative">
            <Avatar className="z-0 ml-3 mt-1 size-11 rounded-lg">
              <AvatarImage
                src={avatarSrc}
                className="h-full w-full rounded-lg"
              />
              <AvatarFallback className="text-xs">{avatarAlt}</AvatarFallback>
            </Avatar>
          </div>
        </>
      ) : (
        <>
          <div className="relative">
            <Avatar className="z-0 mr-3 mt-1 size-11 rounded-lg">
              <AvatarImage
                src={avatarSrc}
                className="h-full w-full rounded-lg"
              />
              <AvatarFallback className="text-xs">{avatarAlt}</AvatarFallback>
            </Avatar>
          </div>
          <div className="w-full">
            <div className="flex items-center justify-start gap-2">
              <span className="font-kanit text-[12px] font-medium">
                {displayName}
              </span>
              <span className="font-montserrat text-[12px] font-semibold text-[#3B6E9C]">
                {formattedTime}
              </span>
            </div>
            <MessageContent />
          </div>
        </>
      )}
    </div>
  );
};

export default MessageCard;
